import { Controller } from "@hotwired/stimulus"

// Copies a pre-rendered text value to the clipboard — used by the
// consignation report's "Copiar para WhatsApp" button (one per seller panel).
export default class extends Controller {
  static targets = ["label"]
  static values = { text: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      return
    }

    const original = this.labelTarget.innerHTML
    this.labelTarget.textContent = "Copiado!"
    clearTimeout(this.resetTimeout)
    this.resetTimeout = setTimeout(() => { this.labelTarget.innerHTML = original }, 2000)
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
  }
}
